module.exports = __webpack_public_path__ + "static/media/logo_branca.62e86789.png";